import { useEffect, useState } from "react";
import { getSelectorsByUserAgent } from "react-device-detect";

// react-device-detect doesn't do typing correctly (returns any), so we have to manually type this.

export function useDeviceDetect() {
  const [isLoading, setIsLoading] = useState(true);
  const [deviceInfo, setDeviceInfo] = useState({});
  useEffect(() => {
    // react-device-detect provides a hook but it doesn't work with SSR
    // so we have to do this manually.
    const info = getSelectorsByUserAgent(window.navigator.userAgent);
    setDeviceInfo(info);
    setIsLoading(false);
  }, []);
  deviceInfo.isLoading = isLoading;
  return deviceInfo;
}